import { Outlet } from 'react-router-dom';
import TrainingProvider, { useTraining } from './TrainingContext';
import TrainingSidebar from './TrainingSidebar';
import TrainingTopbarNew from './TrainingTopbarNew';
import { WarningCircle } from '@phosphor-icons/react';

/* ── Inner layout (needs context) ── */

function TrainingShell() {
  const { orgNotFound, orgLoading, orgDomain, sidebarCollapsed } = useTraining();

  // Org not found screen
  if (orgDomain && orgNotFound && !orgLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
        <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-10 max-w-md w-full text-center">
          <div className="w-16 h-16 bg-amber-50 rounded-full flex items-center justify-center mx-auto mb-5">
            <WarningCircle size={32} weight="fill" className="text-amber-500" />
          </div>
          <h2 className="text-xl font-bold text-gray-900 mb-2 tracking-tight">
            Organisation Not Found
          </h2>
          <p className="text-sm text-gray-500 mb-2 leading-relaxed">
            We couldn&apos;t find an organisation matching <span className="font-semibold text-gray-700">&ldquo;{orgDomain}&rdquo;</span>.
          </p>
          <p className="text-sm text-gray-400 leading-relaxed">
            Please check the URL and try again, or contact your training administrator for the correct link.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      {/* ── Sidebar ── */}
      <TrainingSidebar />

      {/* ── Main area ── */}
      <div className="flex-1 flex flex-col min-w-0">
        <TrainingTopbarNew />
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>

        {/* ── Footer ── */}
        <footer className="border-t border-gray-100 py-4 px-6 text-center text-[11px] text-gray-400">
          &copy; {new Date().getFullYear()} Powered by Trainery One
        </footer>
      </div>
    </div>
  );
}

/* ── Exported layout wrapper ── */

export default function TrainingLayout() {
  return (
    <TrainingProvider>
      <TrainingShell />
    </TrainingProvider>
  );
}
